import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { fetchHotelSummary, setSelection, setView } from "../../../../../Redux/slice/features/hotelOccupancySlice";


const HotelWiseMonthlyOccTable = () => {
  const dispatch = useDispatch();
  const { hotelId, year, hotelSummary } = useSelector((state) => state.hotelOcc);

  useEffect(() => {
    if (hotelId > 0) dispatch(fetchHotelSummary({ hotelId, year }));
  }, [dispatch, hotelId, year]);

  const handleClick = (monthName) => {
    const monthMap = {
      January: 1, February: 2, March: 3, April: 4, May: 5, June: 6,
      July: 7, August: 8, September: 9, October: 10, November: 11, December: 12
    };
    dispatch(setSelection({ hotelId, year, month: monthMap[monthName] }));
    dispatch(setView("detail"));
  };


  return (
    <>
       <div style={{ position: "relative" }}>
      <div className="report-header">
        <h4>Hotel Wise Monthly Occupancy</h4>
      </div>

      <table className="table">
        <thead><tr><th>SL #</th><th>Month</th><th>Total Occupancy</th></tr></thead>
        <tbody>
          {hotelSummary.map((row, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{row.Month}</td>
              <td>
                <button onClick={() => handleClick(row.Month)}>
                  {row.TotalOccupancy}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </>
  );
};

export default HotelWiseMonthlyOccTable;
